module.exports = require("is-empty");